<template>
  <path
    d="M6.29 8.11024L10.18 12.0002L6.29 15.8902C5.9 16.2802 5.9 16.9102 6.29 17.3002C6.68 17.6902 7.31 17.6902 7.7 17.3002L12.29 12.7102C12.68 12.3202 12.68 11.6902 12.29 11.3002L7.7 6.70024C7.31 6.31024 6.68 6.31024 6.29 6.70024C5.91 7.09024 5.91 7.73024 6.29 8.11024ZM17 6.00024C17.55 6.00024 18 6.45024 18 7.00024V17.0002C18 17.5502 17.55 18.0002 17 18.0002C16.45 18.0002 16 17.5502 16 17.0002V7.00024C16 6.45024 16.45 6.00024 17 6.00024Z"
  />
</template>
